import './LastModified.scss';
import React, {useState, useEffect} from "react";
import T from "../../../shared/component/t/T";
import Storage from "../../../helpers/Storage";
import snippets from "../../../helpers/snippets";
import {default as _} from "../../../helpers/Translate"
import {connect} from "react-redux";
import LastModified_History from "./LastModified_History";

function LastModified(props) {
	const [language, setLanguage] = useState(props.language);
	
	const [report, setReport] = useState(props.report)
	const [show, setShow] = useState(false)
	const [ignoreClicked, setIgnoredClicked] = useState(false)
	
	useEffect(() => {
		if (props.report) {
			setReport(props.report)
		}
	}, [props.report]);
	
	useEffect(() => {
		setLanguage(props.language)
	}, [props.language]);
	
	useEffect(() => {
		// here we used ignore only for when user click on status!
		// popover consider it as close opened popover but as it's open, we want to close it!
		// but there is two clicks as one click on status and another is click outside of popover, so we have to close it!
		if (ignoreClicked)
			setTimeout(()=> {setIgnoredClicked(false)}, 100)
	}, [ignoreClicked])
	
	const handlePopover = () => {
		if (ignoreClicked) return
		setShow(!show);
		setIgnoredClicked(true)
	}
	
	const returnsFullMessage = (statusText, userID, userName, dateTime) => {
		return `${_.init(statusText, language)} ` +
		  `${_.init("by", language)} ${ifNameWasNull(userName, userID)} ` +
		  `${_.init("at", language)} ${_.datetime(dateTime)} ` +
		  `${_.init("hour", language)} ${_.datetime2time(dateTime)}`
	}
	
	const ifNameWasNull = (display_name, id) => {
		return display_name || getUsersName(id)
	}
	
	const ownersDetail = (status) => {
		let res = {}
		if (status >= 3) {
			if (!snippets.isObjectEmpty(report.type_time) && !snippets.isObjectEmpty(report?.typist_id)) {
				res = {
					...res, [`typist`]: {
						name: report?.typist_name,
						id: report?.typist_id,
						time: report?.type_time,
						message: returnsFullMessage("report_status_typed", report?.typist_id, report?.typist_name, report?.type_time)
					}
				}
			}
		}
		if (status >= 4) {
			if (!snippets.isObjectEmpty(report.report_time) && !snippets.isObjectEmpty(report?.reporter_id)) {
				res = {
					...res, [`assistant_1`]: {
						name: report?.reporter_name,
						id: report?.reporter_id,
						time: report?.report_time,
						message: returnsFullMessage("report_status_accepted", report?.reporter_id, report?.reporter_name, report?.report_time)
					}
				}
			}
			if (!snippets.isObjectEmpty(report.accept_time) && !snippets.isObjectEmpty(report?.resident2_id)) {
				res = {
					...res, [`assistant_2`]: {
						name: report?.reporter2_name,
						id: report?.resident2_id,
						time: report?.accept_time,
						message: returnsFullMessage("report_status_verified", report?.resident2_id, report?.reporter2_name, report?.accept_time)
					}
				}
			}
		}
		if (status >= 5) {
			if (!snippets.isObjectEmpty(report.verify_time) && !snippets.isObjectEmpty(report?.verifier_id)) {
				res = {
					...res, [`staff`]: {
						name: report?.verifier_name,
						id: report?.verifier_id,
						time: report?.verify_time,
						with_staff: report?.with_staff,
						message: returnsFullMessage("report_status_verified", report?.verifier_id, report?.verifier_name, report?.verify_time)
					}
				}
			}
		}
		return res
	}
	
	const details = (title, value) => {
		return <div className='lastModified' key={title}>
			<div className='__title'>
				{value?.with_staff === false ? <T token={'Verify_without_staff'}/> :
				  value?.with_staff === true ? <T token={'Verify_with_staff'}/> : <T token={title}/>}:
			</div>
			<div className='__info'>
				{ifNameWasNull(value.name, value.id)}
			</div>
		</div>
	}
	
	const detailsWithTime = (value) => {
		return <>
			{!snippets.isObjectEmpty(ifNameWasNull(value?.name, value?.id)) && <div className='lastModified'>
				<div className='__title'>
					<T token={'by'}/>:
				</div>
				<div className='__info'>
					{ifNameWasNull(value?.name, value?.id)}
				</div>
			</div>}
			
			{!snippets.isObjectEmpty(value?.time) &&
			  <div className='lastModifiedWith'>
				  <div className='__title'>
					  <T token={`at`}/>:
				  </div>
				  <div className='__info'>
					  {_.datetime(value?.time)}
				  </div>
			  </div>
			}
		</>
	}
	
	const iteration = (status) => {
		let res = ownersDetail(status)
		
		if (status > 4) {
			return Object.entries(res)?.map(([key, value]) => {
				return details(key, value)
			})
		} else if (status > 2) {
			let info
			switch (status) {
				case 4:
					info = res["assistant_1"] || res["assistant_2"]
					return detailsWithTime(info)
				case 3:
					info = res["typist"]
					return detailsWithTime(info)
			}
		}
	}
	
	const getUsersName = (id) => {
		try{
			return Storage.getUserDisplayName(id);
		} catch (e) {
			return null
		}
	}
	
	const popover = () => {
		return <>
			{report?.status > 3 &&
				<LastModified_History mode={'popover'}
				                      show={show}
				                      onClose={handlePopover}
				                      report={report}
			    />
			}
		</>
	}
	
	return (
	  <div className={"StatusAndLastModified"}>
		  <div className={`status ${report?.status_name}`}
		       onClick={handlePopover}
		  >
                <span>
                    <T token={`report_status_${report?.status_name}`}/>
                </span>
		  </div>
		  {popover()}

		  {report?.status > 2 && iteration(report?.status)}
	  
	  </div>
	)
}


const mapStateToProps = state => {
	const language = state.LangReducer.language;
	const direction = state.LangReducer.direction;
	return {language, direction};
};

export default connect(mapStateToProps)(LastModified);
